export const NOTIFICATION_REQUEST_TIMEOUT = 30000;

/** Bound the entire request, including reading its body. A timeout never means a send was rejected. */
export async function notificationRequest(path, token, init) {
  const controller = new AbortController();
  let timer;
  const perform = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}${path}`, {
      ...(init || {}),
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...((init && init.headers) || {}),
      },
    });
    let data = null;
    try {
      data = await res.json();
    } catch (error) {
      if (res.ok) throw new Error('Could not confirm the notification response.');
    }
    if (!res.ok) {
      const error = new Error((data && data.error) || `Request failed (${res.status})`);
      error.status = res.status;
      throw error;
    }
    if (!data || typeof data !== 'object') throw new Error('Could not confirm the notification response.');
    return data;
  };
  try {
    return await Promise.race([
      perform(),
      new Promise((_, reject) => {
        timer = setTimeout(() => {
          reject(new Error('Notification request timed out. The send may already have started.'));
          controller.abort();
        }, NOTIFICATION_REQUEST_TIMEOUT);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
